<template>
    <AppHeaderDropdown right no-caret>

        <template slot="header">
            <i class="icon-bell"></i>
            <b-badge pill variant="danger" v-if="pendingNotifications > 0">{{pendingNotifications}}</b-badge>
        </template>

        <template slot="dropdown" class="notifications-container">

            <b-dropdown-header tag="div" class="dropdown-menu-lg p-2 w-100">
                <b-row class="w-100 m-0 px-1 mb-1">
                    <b-col class="col-6 text-left p-0 mt-1" style="padding-top: 1px !important;">
                        <i class="icon-speech mr-2"></i>
                        <strong>Notificaciones</strong>
                    </b-col>
                    <b-col class="col-6 text-right p-0 mt-1">
                        <button @click="markAllAsRead" class="btn btn-link btn-sm size-2 p-0">Marcar como leídas</button>
                    </b-col>
                </b-row>
            </b-dropdown-header>

            <b-dropdown-item
                v-for="notification in notifications"
                :key="notification.uuid"
                v-bind:class="{ 'bg-success': !notification.isRead }"
                @click="redirect(notification)"
                class="pl-4">

                <span style="white-space: normal !important;">
                    {{ notification.createdAt | dateFormat('DD/MM/YYYY HH:mm') }} - {{notification.message}}
                </span>

            </b-dropdown-item>

            <b-dropdown-item :to="{name: 'listNotifications'}" class="text-center">
                <span class="font-weight-bold text-muted">Ver todas</span>
            </b-dropdown-item>

        </template>
    </AppHeaderDropdown>
</template>

<script>

    import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';
    import { getNotifications, markNotificationAsRead, markAllNotificationsAsRead } from '@/api/notification-api';

    export default {
        name: 'DefaultHeaderDropdownNotif',
        components: {
            AppHeaderDropdown
        },
        data: () => {
            return {
                notificationsTimer: null,
                notifications: []
            }
        },
        created() {
            this.notificationsTimer = setInterval(this.checkNotifications, 60000);
            this.checkNotifications();
        },
        beforeDestroy() {
            clearInterval(this.notificationsTimer);
        },
        computed: {
            pendingNotifications() {
                return this.notifications.filter((notification) => notification.isRead === false).length;
            }
        },
        methods: {

            checkNotifications() {
                getNotifications()
                    .then((notifications) => {
                        this.notifications = notifications.slice(0, 10);
                    })
                    .catch((error) => {
                        console.log("Error al recuperar las notificaciones del usuario")
                    });
            },

            async markAsRead(notification) {
                if (!notification.isRead) {
                    notification.isRead = true;
                    await markNotificationAsRead(notification.uuid);
                }
            },

            async markAllAsRead() {
                await markAllNotificationsAsRead()
                    .then(() => {
                        this.checkNotifications();
                    });
            },

            redirect(notification) {
                this.markAsRead(notification);
                if (notification.type === 'QUERY'){
                    this.$router.push({name: 'queryOverview', params: { uuid: notification.resourceId }});
                }
            }
        },
    }
</script>

<style scoped>
    i {
        color: #025542;
    }

    .dropdown-item {
        width: 400px !important;
    }

    a.bg-success:hover {
        background-color: #4dbd74 !important;
    }
</style>
